<template>
  <div class="rightSidebar">
    <div class="aside">
      <header></header>
      <div class="aside-box">
        <el-popover v-model="popoverVisble" placement="left" width="175" trigger="click">
          <div class="menu">
            <p class="cur" @click="windowHostsClose">
              <i class="el-icon-document-delete"></i>
              <span>关闭所有窗口</span>
            </p>
            <p class="cur" @click="windowHostsNarrow">
              <i class="el-icon-document-remove"></i>
              <span>最小化所有窗口</span>
            </p>
          </div>
          <div class="cur tc" slot="reference"> <i style="font-size: 25px;" class="el-icon-folder"></i></div>
        </el-popover>
        <!-- <div class="cur tc"> <i style="font-size: 25px;" class="el-icon-folder"></i></div> -->
        <div class="aside-c">
          <div class="tc cur icon-but" :class="item.winVisible ? 'isShow' : ''" v-for="(item, index) in windowHosts" :key="index" @click="handelWindowHost(item, index)">
            <el-tooltip effect="dark" :content="item.menu_name" placement="left">
              <div><i class="el-icon-folder-opened" :class="item.client_route === nowPath ? 'isActive' : ''"></i></div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <window-host v-for="(win, idx) in windowHosts" :key="idx" :idx="idx" :win="win" :activeIndex="activeIndex" @changeVisible="changeVisible" @windowClose="windowClose" @handelActiveIndexChange="handelActiveIndexChange"></window-host>
  </div>
</template>

<script>
import WindowHost from 'common/WindowHost'
import { mapState } from 'vuex'
import { calculateCustomZIndex, calculateWinZIndex } from '../lib/utils'
export default {
  name: 'RightSidebar',
  components: { WindowHost },
  props: {
  },
  data() {
    return {
      activeIndex: '',
      popoverVisble: false
      // windowHosts: this.$store.state.windowHostStore
    }
  },
  watch: {
  },
  computed: {
    nowPath () {
      return this.$route.path.replace(/^\//, '')
    },
    ...mapState({
      windowHosts: state => state.windowHostStore
    })
  },
  methods: {
    handelWindowHost (item, index) {
      if (item.client_route === this.nowPath) {
        return
      }
      let winZIndex = calculateWinZIndex('.windowHost')
      this.windowHosts[index].winVisible = !this.windowHosts[index].winVisible
      this.windowHosts[index].zIndex = winZIndex
      this.$store.dispatch('updateWindowHostStoreAction', this.windowHosts)
      this.activeIndex = this.windowHosts[index].winVisible ? index : ''
    },
    handelActiveIndexChange (index) {
      this.activeIndex = index
    },
    changeVisible (idx) {
      this.windowHosts[idx].winVisible = false
      this.$store.dispatch('updateWindowHostStoreAction', this.windowHosts)
    },
    windowClose (idx) {
      this.$store.dispatch('removeWindowHostStoreAction', idx)
    },
    windowHostsNarrow () {
      Object.keys(this.windowHosts).forEach((key) => {
        this.windowHosts[key].winVisible = false
      })

      this.$store.dispatch('updateWindowHostStoreAction', this.windowHosts)
      this.popoverVisble = false
    },
    windowHostsClose () {
      Object.keys(this.windowHosts).map(key => {
        if (key !== this.nowPath) {
          this.$store.dispatch('removeWindowHostStoreAction', key)
        }
      })

      this.popoverVisble = false
    }
  },
  mounted() {
  }
}
</script>

<style lang="stylus" scoped>
  // .rightSidebar {
  //   position: fixed;
  //   right: 0;
  //   top: 71px;
  //   bottom: 0;
  //   z-index: 3000;
  // }
  .aside {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  // .rightSidebar {
  //   height: 100vh;
  // }
  .aside header {
    height: 78px;
  }
  .aside .aside-c {
    display: flex;
    flex-direction: column;
    gap: .05rem;
    width: 50px;
    flex-grow: 1;
    align-items: center;
    // border-left: 1px solid oklch(86% 0 0 / 1);
  }
  .aside-box {
    display: flex;
    height: 100%;
    border-left: 1px solid oklch(0.86 0 0);
    padding-top: .2rem;
    gap: .2rem;
    flex-direction: column;
  }
  .aside-c i {
    font-size: 25px;
  }
  .tc {
    text-align: center;
  }
  .cur {
    cursor: pointer;
  }
  .isActive {
    color: rgb(87, 135, 255);
  }
  .icon-but {
    width: .8rem;
    height: .8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: oklch(93% 0 0 / 1);
    border-radius: .2rem;
  }
  .isShow {
    background-color: oklch(0.83 0 0);
  }
  .menu {
    display: flex;
    flex-direction: column;
    line-height: .56rem
  }
  .menu > .cur:hover{
    background-color: oklch(93% 0 0 / 1);
  }
</style>



// WEBPACK FOOTER //
// src/common/RightSidebar.vue